import { render, staticRenderFns } from "./ReportItem.vue?vue&type=template&id=b60648b4&scoped=true"
import script from "./ReportItem.vue?vue&type=script&lang=ts"
export * from "./ReportItem.vue?vue&type=script&lang=ts"
import style0 from "./ReportItem.vue?vue&type=style&index=0&id=b60648b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60648b4",
  null
  
)

export default component.exports